// Modules
import { connect } from 'react-redux';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { Page, PageContent, PageHeader, ActionSection } from 'components/page';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import Filters from 'modules/filters/filters';
import Pager from 'components/widgets/pager/pager';
import PurchaseCard from 'components/models/purchases/purchase-card';
import PurchaseOrder from 'services/data/purchase-order';

import * as actions from './store/actions';


// Component
class Purchases extends React.Component {
  static propTypes = {
    query: PropTypes.object,
    currentUserId: PropTypes.number,
    purchaseOrders: PropTypes.array,
    fetching: PropTypes.bool,
    count: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.search = this.search.bind(this);

    this.filterConfig = {
      basic: ['search'],
      advanced: [
        ['search', 'company', 'team', 'ticket'],
        ['date', 'purchasedBy', 'vendor'],
        ['purchaseOrderStatus', 'id']
      ],
      defaults: {
        purchaseOrderStatus: ['Not Fully Charged', 'Not Fully Approved'],
        purchasedBy: [props.currentUserId]
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  componentWillUnmount() {
    actions.clearPageData();
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = PurchaseOrder.formatQuery(query || this.props.query);

    Promise.props({
      purchaseOrders: PurchaseOrder.find(fullQuery),
      count: PurchaseOrder.count({ where: fullQuery.where })
    })
      .then((response) => {
        actions.set({ fetching: false, count: response.count, purchaseOrders: response.purchaseOrders });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { fetching, purchaseOrders, count } = this.props;

    _.forEach(purchaseOrders, (purchaseOrder) => {
      _.set(purchaseOrder, 'update', actions.updatePurchaseOrder);
    });

    return (
      <Page>
        <PageHeader title="Purchases">
          <ActionSection>
            <Filters config={this.filterConfig} />
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching}
          emptyText="No purchases, adjust your filters!"
          emptyTextIcon="svg/filter.svg"
          showEmptyText={!fetching && _.isEmpty(purchaseOrders)}
          className="purchases bg-medium-blue-grey"
        >
          {_.map(purchaseOrders, (purchaseOrder) =>
            <PurchaseCard key={purchaseOrder.id} purchaseOrder={purchaseOrder} />
          )}
          <Pager count={count} />
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  query: state.location.query,
  currentUserId: state.auth.currentUser.id,
  purchaseOrders: state.purchases.purchaseOrders,
  fetching: state.purchases.fetching,
  count: state.purchases.count
}))(Purchases);
